import { MAX_ROUND_POINTS } from './scoring';

/** Health a survival game can start with; the host picks. */
export const SURVIVAL_HEALTH_OPTIONS = [10_000, 15_000, 20_000] as const;
export const DEFAULT_STARTING_HEALTH = 15_000;
/** Every this many rounds, damage grows by `SURVIVAL_RAMP`, so a game always ends. */
export const SURVIVAL_RAMP_EVERY = 3;
export const SURVIVAL_RAMP = 0.5;
/** A survival game stops after this many rounds at most; the healthiest player wins. */
export const MAX_SURVIVAL_ROUNDS = 30;

/** Damage multiplier of a round (0-based): ×1 for rounds 1–3, ×1.5 for 4–6, ×2 for 7–9… */
export function survivalMultiplier(roundIndex: number): number {
  return 1 + SURVIVAL_RAMP * Math.floor(roundIndex / SURVIVAL_RAMP_EVERY);
}

/** Health lost in a round: the points missed (up to 5,000), times the round's multiplier. */
export function survivalDamage(points: number, roundIndex: number): number {
  const missed = Math.max(0, MAX_ROUND_POINTS - Math.min(points, MAX_ROUND_POINTS));
  return Math.round(missed * survivalMultiplier(roundIndex));
}
